<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Fm0F0h/tc-custom/9781488099670.jpg?1725275644629" alt="This image is the cover for the book Carriage House, The Carriage House"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Carriage House, The Carriage House
      </h1>
      <p class="bookDescription body article font2">
        <b>A graphic designer discovers the payment for her recent job comes with a dark secret in this romantic suspense novel by a <i>New York Times</i> bestseller.</b><br/><br/>Fun and a little hard work. That’s all Tess Haviland has in mind when Ike Grantham pays her for her graphic design work with the run-down nineteenth-century carriage house on Boston’s North Shore.<br/><br/>Then Ike disappears, and Tess finds herself with much more than a simple weekend project to get her out of the city. It’s not just the rumors that the carriage house is haunted—it’s the neighbors: six-year-old Dolly Thorne, her reclusive babysitter, Harley Beckett . . . and especially Dolly’s father, Andrew Thorne, who has his own ideas about why Tess has turned up next door.<br/><br/>But when Tess discovers a human skeleton in her dirt cellar, she begins to ask questions about the history of the carriage house, the untimely death of Andrew’s wife . . . and Ike’s disappearance. Questions a desperate killer wants to silence before the truth reveals that someone got away with murder . . . <br/><br/><b><i>Originally published in 2001.</i></b><br/><br/><b>Praise for <i>The Carriage House</i></b><br/><br/>“Carla Neggers is great. She’s done it again with <i>The Carriage House</i>—I love this book!” —Janet Evanovich
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carla Neggers
      </h2>
      
      <p class="authorDescription body article">Carla Neggers is the&#160;<I>New York Times</I> bestselling author of the Sharpe and Donovan series featuring Boston-based FBI agents Emma Sharpe and Colin Donovan and the Swift River Valley series set in small-town New England. With many bestsellers to her credit, Carla and her husband divide their time between their hilltop home in Vermont, their kids&#39; places in Boston and various inns, hotels and hideaways on their travels, frequently to Ireland. Learn more at CarlaNeggers.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01a35224